import { useKeycloak } from "@react-keycloak/web";
import React, { Fragment, useEffect, useState } from "react";
import { Container, Dropdown, Form, InputGroup, Nav, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Searchable from "react-searchable-dropdown";
import Select from "react-select";
import { keycloak } from "../../Authentication/keycloak";
import { auth } from "../../Firebase/firebase";
import { useAuthContext } from "../../context/auth.context";
import { useUserContext } from "../../context/user.context";
import useKeycloakData from "../../hooks/useKeycloakData";
import { StringUtil } from "../../utils/string.util";
import Loader from "../Loader/Loader";
import { useLocation } from "react-router-dom";

// FuScreen-start
function Fullscreen() {
  if ((document.fullScreenElement && document.fullScreenElement === null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
    if (document.documentElement.requestFullScreen) {
      document.documentElement.requestFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
      document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
    }
  } else {
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  }
}

// FullScreen-end
function Header() {
  const { t, i18n } = useTranslation();
  let navigate = useNavigate();
  const initialized = useKeycloak();
  const location = useLocation();

  const { userRoles, merchantArray, setSelectedMerchant, selectedMerchant, isGlobalUserAdmin } = useUserContext();
  const { firstName, lastName, email } = useKeycloakData();
  const authState = useAuthContext();
  const { currentUser } = authState || { currentUser: "NO USER" };

  const [newMerchantName, setNewMerchantName] = useState("");

  useEffect(() => {
    if (newMerchantName !== "") {
      setSelectedMerchant(newMerchantName?.value);
    }
  }, [newMerchantName]);

  //console.log("HEADER USER", { currentUser })
  //i18n.changeLanguage(language)
  if (!initialized) return <Loader />;

  const routeChange = () => {
    let path = `${process.env.PUBLIC_URL}/`;
    navigate(path);
  };

  //  headerToggleButton
  const headerToggleButton = () => {
    let body = document.querySelector("body");
    let innerWidth = window.innerWidth;
    if (body !== !body) {
      if (innerWidth >= 992) {
        document.querySelector("body")?.classList.toggle("main-sidebar-hide");
        document.querySelector("body")?.classList.remove("main-sidebar-show");
      } else if (document.body.classList.contains("horizontalmenu")) {
        document.querySelector("body")?.classList.toggle("main-navbar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-hide");
      } else {
        document.querySelector("body")?.classList.toggle("main-sidebar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-hide");
      }
    }
  };

  function Swicherbutton() {
    document.querySelector(".demo_changer").classList.toggle("active");
    document.querySelector(".demo_changer").style.right = "0px";
  }
  const Darkmode = () => {
    document.querySelector("body").classList.toggle("dark-theme");
  };

  const languages = {
    en: { nativeName: "English" },
    de: { nativeName: "Deutsch" },
  };

  const germanFlag = require("../../assets/img/flags/germany_flag.jpg");
  const engFlag = require("../../assets/img/flags/us_flag.jpg");
  const currentLanguageFlag = i18n.resolvedLanguage === "de" ? germanFlag : engFlag;
  /*console.log("i18n.resolvedLanguage", {
    resolvedLanguage: i18n.resolvedLanguage,
    keys: Object.keys(languages),
  });*/

  const LanguageMenuBar = () => {
    const changeLang = (lng) => {
      //console.log("CALLED CHANGED LANG: ", lng)
      i18n.changeLanguage(lng);
      //sessionStorage.setItem("language", lng);
    };

    return (
      <Dropdown.Menu className="dropdown-menu" style={{ margin: "0px" }}>
        {Object.keys(languages).map((lng) => (
          <Dropdown.Item
            onClick={() => changeLang(lng)}
            key={lng}
            style={{
              fontWeight: i18n.resolvedLanguage === lng ? "bold" : "normal",
            }}
            className="d-flex"
          >
            <span className="avatar  me-3 align-self-center bg-transparent">
              <img src={lng === "de" ? germanFlag : engFlag} alt="img" />
            </span>
            <div className="d-flex">
              <span className="mt-2">{languages[lng].nativeName}</span>
            </div>
          </Dropdown.Item>
        ))}

        {/* <Dropdown.Item className="d-flex ">
          <span className="avatar  me-3 align-self-center bg-transparent">
            <img
              src={require("../../assets/img/flags/french_flag.jpg")}
              alt="img"
            />
          </span>
          <div className="d-flex">
            <span className="mt-2">French</span>
          </div>
        </Dropdown.Item>

        <Dropdown.Item className="d-flex">
          <span className="avatar  me-3 align-self-center bg-transparent">
            <img
              src={require("../../assets/img/flags/germany_flag.jpg")}
              alt="img"
            />
          </span>
          <div className="d-flex">
            <span className="mt-2">Germany</span>
          </div>
        </Dropdown.Item>
        <Dropdown.Item className="d-flex">
          <span className="avatar me-3 align-self-center bg-transparent">
            <img
              src={require("../../assets/img/flags/italy_flag.jpg")}
              alt="img"
            />
          </span>
          <div className="d-flex">
            <span className="mt-2">Italy</span>
          </div>
        </Dropdown.Item>
        <Dropdown.Item className="d-flex">
          <span className="avatar me-3 align-self-center bg-transparent">
            <img
              src={require("../../assets/img/flags/russia_flag.jpg")}
              alt="img"
            />
          </span>
          <div className="d-flex">
            <span className="mt-2">Russia</span>
          </div>
        </Dropdown.Item>
        <Dropdown.Item className="d-flex">
          <span className="avatar  me-3 align-self-center bg-transparent">
            <img
              src={require("../../assets/img/flags/spain_flag.jpg")}
              alt="img"
            />
          </span>
          <div className="d-flex">
            <span className="mt-2">spain</span>
          </div>
        </Dropdown.Item> */}
      </Dropdown.Menu>
    );
  };

  const HeaderToggleButton = (
    <Link to="#" className="main-header-menu-icon" id="mainSidebarToggle" onClick={() => headerToggleButton()}>
      <span></span>
    </Link>
  );

  const HeaderLogoutButton = (
    <Dropdown.Item
      onClick={() => {
        auth.signOut();
        routeChange();
        keycloak.logout();
      }}
    >
      <i className="fe fe-power"></i>
      {` ${t("user.logout")}`}
    </Dropdown.Item>
  );

  const AvatarComponent = (
    <Dropdown.Toggle className="d-flex p-0" variant="default">
      {/* <span className="main-img-user mx-1">
      <img
        alt="avatar"
        src={require("../../assets/img/users/1.jpg")}
      />
    </span> */}

      <div className="avatar bg-warning">{StringUtil.getFirstNameLastNameInitials(firstName, lastName) || "-"}</div>
    </Dropdown.Toggle>
  );

  const displayUserRoles = () => {
    //console.log("HEADER USER ROLES", userRoles?.toString());
    return userRoles?.toString();
  };

  const AvatarDropdownMenu = (
    <Dropdown.Menu style={{ margin: "0px" }}>
      <div className="header-navheading">
        <p className="main-notification-text">
          {/*t("user.active")*/}
          {displayUserRoles()}
        </p>
        <hr />
        <h6 className="main-notification-title">
          {currentUser?.firstName} {currentUser?.lastName}
        </h6>
        <p className="main-notification-text">{selectedMerchant}</p>
        <hr />
        <p className="main-notification-text">{email}</p>
        <hr />
      </div>

      {/* <Dropdown.Item
        className="border-top"
        href={`${process.env.PUBLIC_URL}/pages/profile`}
      >
        <i className="fe fe-user"></i> My Profile
      </Dropdown.Item>

      <Dropdown.Item
        href={`${process.env.PUBLIC_URL}/pages/profile`}
      >
        <i className="fe fe-edit"></i> Edit Profile
      </Dropdown.Item>

      <Dropdown.Item
        href={`${process.env.PUBLIC_URL}/pages/profile`}
      >
        <i className="fe fe-settings"></i> Account Settings
      </Dropdown.Item>

      <Dropdown.Item
        href={`${process.env.PUBLIC_URL}/pages/profile`}
      >
        <i className="fe fe-settings"></i> Support
      </Dropdown.Item>

      <Dropdown.Item
        href={`${process.env.PUBLIC_URL}/pages/profile`}
      >
        <i className="fe fe-compass"></i> Activity
      </Dropdown.Item> */}

      {HeaderLogoutButton}
    </Dropdown.Menu>
  );

  const colorStyles = {
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#000000",
      };
    },
  };

  const MerchantDropDownMenu = () => {
    const merchants = merchantArray?.sort().map((merchant) => ({
      value: merchant,
      label: `${merchant}`,
    }));
    if (merchantArray.length > 1) {
      return (
        <Select
          //id="profession"
          //type="text"
          //placeholder={t("onboarding.step6.professionPlaceholder")}
          className=""
          //closeMenuOnSelect={true}
          //isMulti
          styles={colorStyles}
          options={merchants}
          onChange={(value) => setNewMerchantName(value)}
          value={newMerchantName}
          placeholder={selectedMerchant}
        />
      );
    }
  };

  const HeaderSearchComponent = (
    <Dropdown className="header-search">
      <Dropdown.Toggle variant="default" className="px-0">
        <i className="fe fe-search header-icons fs-18 px-2 lh-5"></i>
      </Dropdown.Toggle>

      <Dropdown.Menu className="p-2">
        <InputGroup>
          <Searchable
            className="form-control select2"
            value="test"
            placeholder="Choose one" // by default "Search"
            notFoundText="No result found" // by default "No result found"
            noInput
            options={[
              {
                value: "",
                label: "All categories",
              },
              {
                value: "it projects",
                label: "IT Projects",
              },
              {
                value: "business case",
                label: "Business Case",
              },
              {
                value: "microsoft project",
                label: "Microsoft Project",
              },
              {
                value: "risk ]management",
                label: "Risk Management",
              },
              {
                value: "popular",
                label: "Popular",
              },
              {
                value: "team building",
                label: "Team Building",
              },
            ]}
            onSelect={(value) => {
              console.log(value);
            }}
            listMaxHeight={140} //by default 140
          />
          <Form.Control type="search" className="rounded-0" placeholder="Search for anything..." />
          <InputGroup.Text className="btn search-btn">
            <i className="fe fe-search"></i>
          </InputGroup.Text>
        </InputGroup>
      </Dropdown.Menu>
    </Dropdown>
  );

  const HeaderDarkModeSwitcher = (
    <Dropdown className="dropdown d-flex main-header-theme">
      <Nav.Link className="nav-link icon layout-setting" onClick={() => Darkmode()}>
        <span className="dark-layout">
          <i className="fe fe-sun header-icons"></i>
        </span>
        <span className="light-layout">
          <i className="fe fe-moon header-icons"></i>
        </span>
      </Nav.Link>
    </Dropdown>
  );

  const HeaderLanguageFlagSwitcher = (
    <Dropdown className=" main-header-notification flag-dropdown">
      <Dropdown.Toggle className="nav-link icon country-Flag " variant="default">
        <span className="avatar align-self-center bg-transparent">
          <img src={currentLanguageFlag} alt="img" />
        </span>

        {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <circle cx="256" cy="256" r="256" fill="#f0f0f0" />
        <g fill="#0052b4">
          <path d="M52.92 100.142c-20.109 26.163-35.272 56.318-44.101 89.077h133.178L52.92 100.142zM503.181 189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075 89.076h133.176zM8.819 322.784c8.83 32.758 23.993 62.913 44.101 89.075l89.074-89.075H8.819zM411.858 52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177l89.076-89.075zM100.142 459.079c26.163 20.109 56.318 35.272 89.076 44.102V370.005l-89.076 89.074zM189.217 8.819c-32.758 8.83-62.913 23.993-89.075 44.101l89.075 89.075V8.819zM322.783 503.181c32.758-8.83 62.913-23.993 89.075-44.101l-89.075-89.075v133.176zM370.005 322.784l89.075 89.076c20.108-26.162 35.272-56.318 44.101-89.076H370.005z" />
        </g>
        <g fill="#d80027">
          <path d="M509.833 222.609H289.392V2.167A258.556 258.556 0 00256 0c-11.319 0-22.461.744-33.391 2.167v220.441H2.167A258.556 258.556 0 000 256c0 11.319.744 22.461 2.167 33.391h220.441v220.442a258.35 258.35 0 0066.783 0V289.392h220.442A258.533 258.533 0 00512 256c0-11.317-.744-22.461-2.167-33.391z" />
          <path d="M322.783 322.784L437.019 437.02a256.636 256.636 0 0015.048-16.435l-97.802-97.802h-31.482v.001zM189.217 322.784h-.002L74.98 437.019a256.636 256.636 0 0016.435 15.048l97.802-97.804v-31.479zM189.217 189.219v-.002L74.981 74.98a256.636 256.636 0 00-15.048 16.435l97.803 97.803h31.481zM322.783 189.219L437.02 74.981a256.328 256.328 0 00-16.435-15.047l-97.802 97.803v31.482z" />
        </g>
      </svg> */}
      </Dropdown.Toggle>

      <LanguageMenuBar />
    </Dropdown>
  );

  const HeaderFullscreenSwitcher = (
    <div className="d-md-flex">
      <div className="nav-link icon full-screen-link" onClick={Fullscreen}>
        <i className="fe fe-maximize fullscreen-button fullscreen header-icons"></i>
        <i className="fe fe-minimize fullscreen-button exit-fullscreen header-icons"></i>
      </div>
    </div>
  );

  const HeaderUserNotificationComponent = (
    <Dropdown className=" main-header-notification">
      <Dropdown.Toggle className="nav-link icon" href="#" variant="default">
        <i className="fe fe-bell header-icons"></i>
        <span className="badge bg-danger nav-link-badge">4</span>
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ margin: "0px" }}>
        <div className="header-navheading">
          <p className="main-notification-text">
            You have 1 unread notification
            <span className="badge bg-pill bg-primary ms-3">View all</span>
          </p>
        </div>
        <div className="main-notification-list">
          <div className="media new">
            <div className="main-img-user online">
              <img alt="avatar" src={require("../../assets/img/users/5.jpg")} />
            </div>
            <div className="media-body">
              <p>
                Congratulate <strong>Olivia James</strong> for New template start
              </p>
              <span>Oct 15 12:32pm</span>
            </div>
          </div>
          <div className="media">
            <div className="main-img-user">
              <img alt="avatar" src={require("../../assets/img/users/2.jpg")} />
            </div>
            <div className="media-body">
              <p>
                <strong>Joshua Gray</strong> New Message Received
              </p>
              <span>Oct 13 02:56am</span>
            </div>
          </div>
          <div className="media">
            <div className="main-img-user online">
              <img alt="avatar" src={require("../../assets/img/users/3.jpg")} />
            </div>
            <div className="media-body">
              <p>
                <strong>Elizabeth Lewis</strong> added new schedule realease
              </p>
              <span>Oct 12 10:40pm</span>
            </div>
          </div>
        </div>
        <div className="dropdown-footer">
          <Link to="#">View All Notifications</Link>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );

  const HeaderChatNotificationsComponent = (
    <div className="main-header-notification">
      <Link className="icon nav-link" to={`${process.env.PUBLIC_URL}/advanceUI/chat/`}>
        <i className="fe fe-message-square header-icons"></i>
        <span className="badge bg-success nav-link-badge">6</span>
      </Link>
    </div>
  );

  const HeaderAdvancedSearchInput = (
    <InputGroup>
      <Searchable
        className="form-control select2"
        value="test"
        placeholder="Choose one" // by default "Search"
        notFoundText="No result found" // by default "No result found"
        noInput
        options={[
          {
            value: "",
            label: "All categories",
          },
          {
            value: "it projects",
            label: "IT Projects",
          },
          {
            value: "business case",
            label: "Business Case",
          },
          {
            value: "microsoft project",
            label: "Microsoft Project",
          },
          {
            label: "Risk Management",
          },
          {
            value: "popular",
            label: "Popular",
          },
          {
            value: "team building",
            label: "Team Building",
          },
        ]}
        onSelect={(value) => {
          console.log(value);
        }}
        listMaxHeight={140} //by default 140
      />
      <Form.Control type="search" className="rounded-0" placeholder="Search for anything..." />
      <InputGroup.Text className="btn search-btn">
        <i className="fe fe-search"></i>
      </InputGroup.Text>
    </InputGroup>
  );

  const HeaderMobileResponsiveLogo = (
    <div className="responsive-logo">
      <Link to={`${process.env.PUBLIC_URL}/`}>
        <img src={require("../../assets/logo/smarpay-logo-small.png")} className="mobile-logo" alt="logo" />
      </Link>
      <Link to={`${process.env.PUBLIC_URL}/`}>
        <img src={require("../../assets/logo/smarpay-logo-light-small.png")} className="mobile-logo-dark" alt="logo" />
      </Link>
    </div>
  );

  const HeaderDemoThemeSwitcher = (
    <div className="d-flex header-setting-icon demo-icon fa-spin">
      <Nav.Link className="nav-link icon" onClick={Swicherbutton}>
        <i className="fe fe-settings settings-icon "></i>
      </Nav.Link>
    </div>
  );

  return (
    <Fragment>
      <Navbar
        expand="lg"
        className="main-header side-header sticky"
        // style={{ marginBottom: "-64px" }}
      >
        <Container fluid className="main-container container-fluid">
          <div className="main-header-left">
            {HeaderToggleButton}
            <>
              <div className="hor-logo">
                <Link to={`${process.env.PUBLIC_URL}/dashboard/`} className="main-logo">
                  <img src={require("../../assets/logo/smarpay-logo-small.png")} className="header-brand-img desktop-logo" alt="logo" />
                  <img src={require("../../assets/logo/smarpay-logo-light-small.png")} className="header-brand-img desktop-logo-dark" alt="logo" />
                </Link>
              </div>

              <div className="main-header-message tx-15">
                {" "}
                {`${t("general.welcome")} `}
                <strong>{`${firstName} ${lastName}`}</strong> - {selectedMerchant}
              </div>
            </>
          </div>

          <div className="wd-30p">
            {/* HeaderMobileResponsiveLogo */}

            {/* HeaderAdvancedSearchInput */}

            {(merchantArray.length > 1 || isGlobalUserAdmin) && MerchantDropDownMenu()}
          </div>

          <div className="main-header-right">
            <Navbar.Toggle aria-controls="navbarSupportedContent-4" className="navresponsive-toggler">
              <i className="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
            </Navbar.Toggle>
            <div className="navbar navbar-expand-lg nav nav-item navbar-nav-right responsive-navbar navbar-dark">
              <Navbar.Collapse className="collapse navbar-collapse" id="navbarSupportedContent-4">
                <div className="d-flex order-lg-2 align-items-center ms-auto">
                  {/* HeaderSearchComponent */}

                  {/* HeaderDarkModeSwitcher */}

                  {HeaderLanguageFlagSwitcher}

                  {/* HeaderFullscreenSwitcher */}

                  {/* HeaderUserNotificationComponent */}

                  {/* HeaderChatNotificationsComponent */}

                  <Dropdown className="main-profile-menu">
                    {AvatarComponent}

                    {AvatarDropdownMenu}
                  </Dropdown>

                  {HeaderLogoutButton}

                  {/* <div className="d-md-flex header-settings">
                    <Nav.Link
                      href="#"
                      className="nav-link icon"
                      onClick={() => openCloseSidebar1()}
                    >
                      <i className="fe fe-align-right header-icons"></i>
                    </Nav.Link>
                  </div> */}
                </div>
              </Navbar.Collapse>

              {/* HeaderDemoThemeSwitcher */}
            </div>
          </div>
        </Container>
      </Navbar>
    </Fragment>
  );
}

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
